import getAxiosInstance from 'app/config/api';
import axios from 'axios';
import domainModel from 'domain-model';
import withFormsyValidations from 'flaivy-react/components/withFormsyValidations';
import { propTypes } from 'formsy-react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import qs from 'qs';
import React, { Component } from 'react';
import { components } from 'react-select';
import Async from 'react-select/async';

const endPoint = '/invoices';

let cancelTokenSource = null;

/* eslint-disable */
const MenuList = props => {
  return (
    <components.MenuList {...props}>
      <table className="table w-100 mt-n1">
        <caption>
          Lista med sökresultat,{' '}
          {props.options.length === 0
            ? 'sökningen gav inget resultat'
            : 'skriv för att söka efter fler.'}
        </caption>
        <thead className="table-light">
          <tr>
            <th className="text-nowrap text-center w-100 py-1">Fakturadatum</th>

            <th className="text-nowrap text-center w-100 py-1">
              Fakturanummer
            </th>

            <th className="text-nowrap text-center w-100 py-1">
              Förfallodatum
            </th>

            <th className="text-nowrap text-center w-100 py-1">
              leveransdatum
            </th>

            <th className="text-nowrap text-center w-100 py-1">
              Betalningsdatum (när betalningen kom in)
            </th>
          </tr>
        </thead>
        <tbody>{props.children}</tbody>
      </table>
    </components.MenuList>
  );
};

const Option = props => {
  return (
    <tr
      id={props.innerProps.id}
      ref={props.innerRef}
      className={
        (props.isSelected ? 'table-active' : '') +
        ' ' +
        (props.isFocused ? 'bg-light' : '') +
        ' select-option'
      }
      onClick={() => {
        props.selectOption(props.data);
      }}
    >
      <td className="text-nowrap py-1">{props.data.invoiceDate}</td>

      <td className="text-nowrap py-1">{props.data.invoiceNumber}</td>

      <td className="text-nowrap py-1">{props.data.dueDate}</td>

      <td className="text-nowrap py-1">{props.data.deliveryDate}</td>

      <td className="text-nowrap py-1">{props.data.finalPayDate}</td>
    </tr>
  );
};

/* eslint-enable */
class InvoiceSelect extends Component {
  static get propTypes() {
    return {
      name: PropTypes.string.isRequired,
      value: PropTypes.object,
      isDisabled: PropTypes.bool,
      onChange: PropTypes.func.isRequired,
      styles: PropTypes.object,
      query: PropTypes.object,
      ...propTypes,
    };
  }

  static get defaultProps() {
    return {
      isDisabled: false,
      value: null,
      styles: undefined,
      query: {},
    };
  }

  constructor(props) {
    super(props);
    this.search = this.search.bind(this);
    this.selectHandler = this.selectHandler.bind(this);
  }

  async selectHandler(selectedEntity) {
    const { onChange, name, setValue } = this.props;
    const requestUrl = `${endPoint}/${selectedEntity.id}`;
    const response = await getAxiosInstance().get(requestUrl);
    const fullEntity = response.data;
    setValue(fullEntity);
    onChange(name, fullEntity);
  }

  async search(inputValue) {
    const { query } = this.props;
    const queryStr = qs.stringify({
      query: {
        cancelled: false,
        ...domainModel.invoice.createSearchStringQuery(inputValue),
        ...query,
      },
      cacheBuster: new Date().getTime(),
    });
    const requestUrl = `${endPoint}?${queryStr}`;
    if (cancelTokenSource) {
      cancelTokenSource.cancel();
    }
    cancelTokenSource = axios.CancelToken.source();
    const response = await getAxiosInstance().get(`${requestUrl}`, {
      cancelToken: cancelTokenSource.token,
    });

    cancelTokenSource = null;
    return response.data.rows;
  }

  render() {
    const {
      props: { name, value, isDisabled, isValid, styles },
      search,
    } = this;
    return (
      <Async
        cacheOptions
        instanceId={`select-${name}`}
        className={!isValid ? 'border border-danger' : ''}
        components={{ MenuList, Option }}
        name={name}
        value={value}
        isDisabled={isDisabled}
        placeholder="Skriv för att söka ..."
        noOptionsMessage={() => ''}
        loadOptions={search}
        defaultOptions
        getOptionValue={option => option.id}
        getOptionLabel={option =>
          [
            option.invoiceDate,

            option.invoiceNumber,

            option.dueDate,

            option.deliveryDate,

            option.finalPayDate,
          ]
            .filter(x => x)
            .join(' - ')
        }
        onChange={this.selectHandler}
        styles={styles}
      />
    );
  }
}

export default withFormsyValidations(InvoiceSelect, props => ({
  requiredValidation(values, value) {
    if (props.required) {
      return !!value && !_.isEmpty(value);
    }
    return true;
  },
}));
